// ProtectedRoute.js

import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const ProtectedRoute = ({ element, requiredRole }) => {
  const { isAuthenticated, userRole } = useAuth();

  useEffect(() => {
    // Add any loading indicator logic here if needed
  }, [isAuthenticated]);

  if (isAuthenticated === null) {
    // While authentication is being determined, return null or a loading indicator
    return null;
  }

  if (!isAuthenticated) {
    // If not authenticated, redirect to the login page
    return <Navigate to="/" />;
  }

  if (requiredRole && !requiredRole.includes(userRole)) {
    // If authenticated but lacks the required role, redirect to "not authorized"
    return <Navigate to="/not-authorized" />;
  }

  // If authenticated and has the correct role, render the element
  return element;
};

export default ProtectedRoute;
